import { Checkbox } from '@/components/ui/checkbox'
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip'

/**
 * The org member table's Guest checkbox. Owners and admins are never guests
 * (board b0hx), so for them it is unchecked, disabled and explains why on hover.
 */
export function GuestCheckbox({
  checked,
  onCheckedChange,
  disabled,
  lockedReason,
}: {
  checked: boolean
  onCheckedChange: (checked: boolean) => void
  disabled?: boolean
  /** Set when the row's role rules out the guest flag; shown as the tooltip. */
  lockedReason: string | null
}) {
  if (!lockedReason) {
    return (
      <Checkbox
        checked={checked}
        onCheckedChange={(value) => onCheckedChange(value === true)}
        disabled={disabled}
      />
    )
  }
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          {/* A disabled button gets no pointer events — the span carries the hover. */}
          <span className="inline-flex" tabIndex={0}>
            <Checkbox checked={false} disabled aria-label={lockedReason} />
          </span>
        </TooltipTrigger>
        <TooltipContent>
          <p>{lockedReason}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  )
}
